import Link from "next/link";
import type { PostMeta } from "~/lib/mdx";

type Props = {
  post: PostMeta;
};

export const PostCard: React.FC<Props> = ({ post }) => {
  const formattedDate = new Date(post.date).toLocaleString("pl-PL", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="group flex flex-col rounded-xl border border-gray-200 bg-white shadow-sm transition-shadow hover:shadow-md">
      <Link
        href={`/poradnik/${post.slug}`}
        className="flex flex-grow flex-col p-6"
      >
        <span className="mb-3 inline-block self-start rounded-full bg-sky-100 px-3 py-1 text-xs font-medium text-sky-800">
          {post.category}
        </span>
        <h2 className="mb-3 text-lg font-semibold text-gray-900 group-hover:text-sky-800">
          {post.title}
        </h2>
        <p className="mb-4 flex-grow text-sm text-gray-600 leading-relaxed">
          {post.excerpt}
        </p>
        <time className="text-xs text-gray-400" dateTime={post.date}>
          {formattedDate}
        </time>
      </Link>
    </div>
  );
};
